/**
 * PMDashboardLayout
 * Simple layout for PM dashboard and programs list (NO sidebar)
 * Full-width layout with just top navigation
 */

import { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import AppShell from '../components/ui/AppShell'
import UserMenu from '../components/ui/UserMenu'
import RecentProgramsNav from '../components/RecentProgramsNav'
import { PM_NAV } from './navConfig'
import { useTypedNavigate, ROUTES } from '../lib/routing'
import { useUser } from '../contexts/UserContext'

interface PMDashboardLayoutProps {
  children?: ReactNode
}

const PMDashboardLayout = ({ children }: PMDashboardLayoutProps) => {
  const navigate = useTypedNavigate()
  const { user, logout } = useUser()

  const handleLogout = () => {
    logout()
    navigate(ROUTES.public.login)
  }

  return (
    <AppShell
      nav={PM_NAV}
      sidebarExtra={() => <RecentProgramsNav />}
      footer={(collapsed) => (
        <UserMenu
          collapsed={collapsed}
          onLogout={handleLogout}
          userName={user?.full_name || 'User'}
          userOfficeName={user?.office?.name || 'Office'}
        />
      )}
    >
      {children || <Outlet />}
    </AppShell>
  )
}

export default PMDashboardLayout

